// 空调电器行业
import { getPartitioningChild } from '@/utils/api'

export default {
  state: {
    // 产品类型列表
    productTypeList: [],
  },
  getters: {},
  mutations: {
    // 设置产品类型列表
    setProductType(state, data) {
      state.productTypeList = [...data]
    },
  },
  actions: {
    // 获取产品类型列表
    async getProductType({ commit }) {
      let [err, res] = await getPartitioningChild(5)
      if (err) return
      // 保存车型列表
      commit('setProductType', res)
    },
  }
}
